import { inject, Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { IGetPortfolioConfig } from '../interfaces/get-portfolio-config.interface';
import { PortfolioConfigName } from '../constants/portfolio-config-names.const';
import {
    InvestmentDataColumnConfiguration,
    InvestmentDataSectionType,
    InvestmentDataWidgetConfiguration,
} from '@wdx/shared/swagger-gen';

@Injectable()
export class PortfolioConfigService {
    private widgetConfig$?: Observable<InvestmentDataWidgetConfiguration>;
    private portfolioConfig = inject(IGetPortfolioConfig);

    public getWidgetConfig$(
        widgetName: PortfolioConfigName,
    ): Observable<InvestmentDataWidgetConfiguration> {
        if (this.widgetConfig$) {
            return this.widgetConfig$;
        }
        this.widgetConfig$ = this.portfolioConfig.get().pipe(
            map(
                (config) =>
                    config?.widgets?.find(
                        ({ name }) => name === widgetName.toString(),
                    ) as InvestmentDataWidgetConfiguration,
            ),
            shareReplay(1),
        );
        return this.widgetConfig$;
    }

    public getPrimaryColumns$(
        widgetName: PortfolioConfigName,
    ): Observable<InvestmentDataColumnConfiguration[]> {
        return this.getWidgetConfig$(widgetName).pipe(
            map(
                (config) =>
                    config?.columns?.filter(
                        ({ sectionType }) =>
                            sectionType === InvestmentDataSectionType.Primary,
                    ) ?? [],
            ),
        );
    }

    public getExpandedColumns$(
        widgetName: PortfolioConfigName,
    ): Observable<InvestmentDataColumnConfiguration[]> {
        return this.getWidgetConfig$(widgetName).pipe(
            map(
                (config) =>
                    config?.columns?.filter(
                        ({ sectionType }) =>
                            sectionType ===
                            InvestmentDataSectionType.ExpandedArea,
                    ) ?? [],
            ),
        );
    }
}
